// config of canEd-dev
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBshhUtbqToJB6uOnVeHkuOMWkZYVmIp_M',
  authDomain: 'caned-dev.firebaseapp.com',
  databaseURL: 'https://caned-dev.firebaseio.com',
  projectId: 'caned-dev',
  storageBucket: 'caned-dev.appspot.com',
  messagingSenderId: '1070665185320'
}

export const SERVER_URL = "https://api.canedconsulting.ca"



// WEBPACK FOOTER //
// ./src/config.js